import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FlexLayoutModule } from '@angular/flex-layout';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
//import { RavenComponent} from './pages/raven/raven.component';
import { MatMenuModule} from '@angular/material/menu';
import { MatIconModule} from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatToolbarModule} from '@angular/material/toolbar';
//import { FooterComponent} from './pages/footer/footer.component'
//import { ContentComponent } from './content/content.component';
import { MatSidenavModule } from '@angular/material/sidenav';

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TemplateModule } from './template/template.module';
import { ThemeServiceService } from './services/theme-service.service';
import { DecimalPipe } from '@angular/common';
import { PagesModule } from './pages/pages.module';



@NgModule({
  declarations: [
    AppComponent,
    //HomeComponent
    //RavenComponent,
    //FooterComponent,
    //ContentComponent
    ],
  exports: [MatSidenavModule],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatMenuModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatToolbarModule,
    MatSidenavModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    TemplateModule,
    PagesModule
  ],
  providers: [ThemeServiceService, DecimalPipe],
  bootstrap: [AppComponent ]
})
export class AppModule { }

